export default (ctx) => {
  if (ctx.route.path !== '/sources/products/denoms') return

  return ctx.redirect('/sources/products/denoms-v2')
}
